import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { HeaderPagesService } from '../header-pages.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  dataModel = {
    username: '',
    emailId: '',
  };

  constructor(
    private dialogRef: MatDialogRef<ForgotPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private headerPagesService: HeaderPagesService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void { 
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
  }

  ngOnDestroy() {
    this.sharedService.isPopupOpened.emit({ isPopupOpened: false});
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    this.sharedService.showErrorMessage.emit({error: "", displayError: false});
    this.sharedService.showSuccessMessage.emit({success: "", displaySuccess: false});
  }

  saveClick() {
    this.sharedService.showPopupErrorMessage.emit({error: "", displayError: false});
    let errors = '';
    this.dataModel.username = this.dataModel.username.trim();
    this.dataModel.emailId = this.dataModel.emailId.trim();

    if (!this.dataModel.username) {
      errors += 'Please enter Username.<br/>';
    }
    if (!this.dataModel.emailId) {
      errors += 'Please enter Email Address.<br/>';
    }

    if (errors) {
      this.sharedService.showPopupErrorMessage.emit({error: errors, displayError: true});
      return;
    }

    this.headerPagesService.forgetPasswordLink(this.dataModel.username, this.dataModel.emailId).subscribe((res: any) => {
      if (res) {
        try {
          res = JSON.parse(res);
          if (res.ValidationErrors && res.ValidationErrors.length > 0) {
            this.sharedService.showPopupErrorMessage.emit({error: res.ValidationErrors[0].ErrorMessage, displayError: true});
            return;
          }else
          {
            this.sharedService.showSuccessMessage.emit({success: "An email sent to your registered email id.", displaySuccess: true});
            this.dialogRef.close(true);
          }
        } catch {
          this.sharedService.showSuccessMessage.emit({success: res, displaySuccess: true});
          this.dialogRef.close(true);
        }
      }
    });

  }

  cancelClick(): void {
    this.dialogRef.close();
  }
}
